import { apiClient } from "@/api/api-client";
import { ApiResponse } from "@/types/api-response";
import {
  ProductVariant,
  ProductVariantCreateRequest,
  ProductVariantUpdateRequest,
} from "@/types/product-variant-type";

// Get product variants by product ID
export async function getProductVariants(
  productId: string
): Promise<ApiResponse<any[]>> {
  try {
    const response = await apiClient.get<any[], object>(
      `/products/${productId}/variants`
    );
    return response;
  } catch (error) {
    console.error("Error fetching product variants:", error);
    throw error;
  }
}

export async function getAll(
): Promise<ApiResponse<ProductVariant[]>> {
  try {
    const response = await apiClient.get<ProductVariant[], object>(
      '/product-variants'
    );
    return response;
  } catch (error) {
    console.error("Error fetching product variants:", error);
    throw error;
  }
}

// Update product variant - matches Java PUT endpoint
export async function updateProductVariant(
  variantId: string,
  updates: ProductVariantUpdateRequest
): Promise<ApiResponse<any>> {
  try {
    const response = await apiClient.put(
      `/product-variants/${variantId}`,
      updates
    );
    console.log("Product variant updated:", response.data);
    return response;
  } catch (error) {
    console.error("Error updating product variant:", error);
    throw error;
  }
}

// Create product variant - matches Java ProductVariantCreateRequest
export async function createProductVariant(
  variantData: ProductVariantCreateRequest
): Promise<ApiResponse<any>> {
  try {
    const response = await apiClient.post("/product-variants", variantData);
    console.log("Product variant created:", response.data);
    return response;
  } catch (error) {
    console.error("Error creating product variant:", error);
    throw error;
  }
}

// Delete product variant - matches Java DELETE endpoint
export async function deleteProductVariant(
  variantId: string
): Promise<ApiResponse<void>> {
  try {
    const response = await apiClient.delete<void>(
      `/product-variants/${variantId}`
    );
    console.log("Product variant deleted:", variantId);
    return response;
  } catch (error) {
    console.error("Error deleting product variant:", error);
    throw error;
  }
}
